// Caremory avatar palette. Warm hues only — no teal / cool-cyan — so family
// chips sit on the cream canvas without clashing with the brand red. Each
// gradient is deterministically picked from the profile seed so the same
// family member keeps the same color across renders. See branding/REBRAND_PLAN.md.
export const PALETTE = [
  'linear-gradient(135deg, #FF5A5F, #F04B50)', // brand red — recent/active family
  'linear-gradient(135deg, #F59E0B, #F97316)', // amber → orange
  'linear-gradient(135deg, #F97316, #EF4444)', // orange → coral
  'linear-gradient(135deg, #EC4899, #F97316)', // pink → orange
  'linear-gradient(135deg, #8B5CF6, #EC4899)', // violet → pink
  'linear-gradient(135deg, #6366F1, #8B5CF6)', // indigo → violet
  'linear-gradient(135deg, #4DA575, #2E7A52)', // caremory event-vax greens
  'linear-gradient(135deg, #8B5CC8, #6A3FA3)', // caremory event-lab violets
] as const;

export function pickAvatarColor(seed?: string | null): string {
  if (!seed) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
